import { FramedImage } from "@/components/FramedImage";
import { RichHtml } from "@/components/WikiLinks";
import { templateOf } from "@/lib/templates";

const HOUSE_CLIP = "polygon(0 0,100% 0,100% 88%,50% 100%,0 88%)";

export const Infobox = ({ article, template }) => {
  const rows = (article.infobox || []).filter((f) => f.label && f.value_html);
  if (!article.infobox_image && rows.length === 0) return null;
  const shape = templateOf(template).image_shape;
  const fallback = shape === "landscape" ? "landscape" : "portrait";
  return (
    <aside data-testid="wiki-infobox-card" className="vellum gilt">
      <div className="bg-[color:var(--accent)] text-[#fdf6e3] px-5 py-3 text-center border-b-2 border-[#c9a227]">
        <p className="font-heading font-bold tracking-wide">{article.title}</p>
      </div>
      {article.infobox_image && (
        <figure className="p-4 pb-2">
          <FramedImage testid="wiki-infobox-image" src={article.infobox_image} alt={article.title} aspect={article.infobox_aspect} fallback={fallback}
            className="border border-[#c9a227] bg-[#1a120c]" clip={shape === "shield" && article.infobox_aspect !== "original" ? HOUSE_CLIP : undefined} />
          {article.infobox_caption && <figcaption className="text-center text-sm italic mt-2 text-[#5e4a35]">{article.infobox_caption}</figcaption>}
        </figure>
      )}
      <dl className="px-5 pb-5 pt-2">
        {rows.map((f, i) => (
          <div key={i} className="grid grid-cols-[minmax(6rem,40%)_1fr] gap-3 py-2.5 border-b border-[#c9a227]/30 last:border-0">
            <dt className="font-heading text-[11px] font-bold uppercase tracking-[0.14em] text-[#5e4a35] pt-0.5">{f.label}</dt>
            <RichHtml as="dd" className="wiki-value text-[15px] leading-snug" html={f.value_html} />
          </div>
        ))}
      </dl>
    </aside>
  );
};
